export default [
  'fetchMenuElement',
]



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/menu/menuTypes.js